/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { ImageModel } from '../model/imageModel';
import { PhoneCaptureInfo } from '../model/phoneCaptureInfo';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class PhoneCaptureApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public getPhoneCaptureInfoObservable: PhoneCaptureInfo | undefined = undefined;

    /**
     * 
     * 
     * @param jobId 
     */
    @action
    public getPhoneCaptureInfo(jobId: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PhoneCaptureInfo> {
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling getPhoneCaptureInfo.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<PhoneCaptureInfo>(
            `${this.basePath}/api/phone-capture/${encodeURIComponent(String(jobId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getPhoneCaptureInfoObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public uploadImageObservable: ImageModel | undefined = undefined;

    /**
     * 
     * 
     * @param linkId 
* @param file 
     */
    @action
    public uploadImage(linkId: string, file?: Blob, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ImageModel> {
        if (linkId === null || linkId === undefined) {
            throw new Error('Required parameter linkId was null or undefined when calling uploadImage.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        let formParams: { append(param: string, value: any): void; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = consumes.includes('multipart/form-data');
        if (useForm) {
            formParams = new FormData();
        } else {
            // TODO: this fails if a parameter is a file, the api can't consume "multipart/form-data" and a blob is passed.
            convertFormParamsToString = true;
            formParams = new URLSearchParams('');
            // set the content-type explicitly to avoid having it set to 'text/plain'
            headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
        }

        if (file !== undefined) {
            formParams.append('file', <any>file);
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ImageModel>(
            `${this.basePath}/api/phone-capture/${encodeURIComponent(String(linkId))}/UploadImage`,
            convertFormParamsToString ? formParams.toString() : formParams,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.uploadImageObservable = response.data);
            }
            return response;
        });
    }

}
